import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimoniols',
  templateUrl: './testimoniols.component.html',
  styleUrls: ['./testimoniols.component.css']
})
export class TestimoniolsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
